<template>
  <Modal
    ref="modal"
    title="Sammelversand"
    class="modal-shipping-bulk"
  >
    <template v-slot:content>
      <p class="u-text-dimmed">Bei dieser Versandart werden die <b>{{ $store.getters.getSelectedQty }} Präsente</b> gebündelt an einen oder mehrere Standorte gesendet (mind. 2 Präsente pro Adresse). Abhängig von der Stückzahl erfolgt der Versand per Paketdienst oder Spedition.</p>

      <FlashMessage
        v-if="$parent.errors.length"
        type="error"
      >
        <p>{{ $parent.errors[0].message }}</p>
      </FlashMessage>

      <ModuleSection>
        <div class="grid-2_xs-1-spaceBetween-equalHeight u-grid-small-gutter u-mb-2">
          <div class="col">
            <FancyChooser
              @click="selectionData.bulk.multipleLocations = false"
              :isSelected="selectionData.bulk.multipleLocations === false"
            >
              <template v-slot:title>Ein Standort</template>
              <template v-slot:icon>
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0)"><path d="M1.06665 30.9333H30.9333M5.06665 5.06665H26.9333H5.06665ZM5.06665 5.06665H27.0667V31.0667H5.06665V5.06665ZM26.9333 30.9333H5.06665H26.9333ZM26.9333 5.06665H5.06665L6.93332 1.06665H25.0667L26.9333 5.06665Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.99989 9.46654C9.73322 9.46654 9.46655 9.3332 9.46655 9.06654M18.9332 27.9999C18.9332 26.3999 17.5999 25.0665 15.9999 25.0665C14.3999 25.0665 13.0666 26.3999 13.0666 27.9999V30.9332H19.0666V27.9999H18.9332ZM9.99989 8.5332C10.2666 8.5332 10.5332 8.79987 10.5332 9.06654L9.99989 8.5332ZM9.46655 9.06654C9.46655 8.79987 9.73322 8.5332 9.99989 8.5332L9.46655 9.06654Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.99989 15.4667C9.73322 15.4667 9.46655 15.2 9.46655 14.9333M10.5332 9.06665C10.5332 9.33332 10.2666 9.59998 9.99989 9.59998L10.5332 9.06665ZM9.99989 14.5333C10.2666 14.5333 10.5332 14.8 10.5332 15.0667L9.99989 14.5333ZM9.46655 14.9333C9.46655 14.6666 9.73322 14.4 9.99989 14.4L9.46655 14.9333Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.46655 21.0667C9.46655 20.8 9.73322 20.5333 9.99989 20.5333M10.5332 14.9333C10.5332 15.2 10.2666 15.4667 9.99989 15.4667L10.5332 14.9333ZM9.99989 20.5333C10.2666 20.5333 10.5332 20.8 10.5332 21.0667L9.99989 20.5333Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.4666 9.06654C15.4666 8.79987 15.7332 8.5332 15.9999 8.5332M9.99989 21.4665C9.73322 21.4665 9.46655 21.1999 9.46655 20.9332L9.99989 21.4665ZM10.5332 21.0665C10.5332 21.3332 10.2666 21.5999 9.99989 21.5999L10.5332 21.0665ZM15.9999 8.5332C16.2666 8.5332 16.5332 8.79987 16.5332 9.06654L15.9999 8.5332Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.9999 15.4667C15.7332 15.4667 15.4666 15.2 15.4666 14.9333M15.9999 9.46668C15.7332 9.46668 15.4666 9.20002 15.4666 8.93335L15.9999 9.46668ZM16.5332 9.06668C16.5332 9.33335 16.2666 9.60002 15.9999 9.60002L16.5332 9.06668ZM15.9999 14.5333C16.2666 14.5333 16.5332 14.8 16.5332 15.0667L15.9999 14.5333ZM15.4666 14.9333C15.4666 14.6667 15.7332 14.4 15.9999 14.4L15.4666 14.9333Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.4666 21.0667C15.4666 20.8 15.7332 20.5333 15.9999 20.5333M16.5332 14.9333C16.5332 15.2 16.2666 15.4667 15.9999 15.4667L16.5332 14.9333ZM15.9999 20.5333C16.2666 20.5333 16.5332 20.8 16.5332 21.0667L15.9999 20.5333Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21.4666 9.06654C21.4666 8.79987 21.7332 8.5332 21.9999 8.5332M15.9999 21.4665C15.7332 21.4665 15.4666 21.1999 15.4666 20.9332L15.9999 21.4665ZM16.5332 21.0665C16.5332 21.3332 16.2666 21.5999 15.9999 21.5999L16.5332 21.0665ZM21.9999 8.5332C22.2666 8.5332 22.5332 8.79987 22.5332 9.06654L21.9999 8.5332Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21.9999 15.4667C21.7332 15.4667 21.4666 15.2 21.4666 14.9333M21.9999 9.46668C21.7332 9.46668 21.4666 9.20002 21.4666 8.93335L21.9999 9.46668ZM22.5332 9.06668C22.5332 9.33335 22.2666 9.60002 21.9999 9.60002L22.5332 9.06668ZM21.9999 14.5333C22.2666 14.5333 22.5332 14.8 22.5332 15.0667L21.9999 14.5333ZM21.4666 14.9333C21.4666 14.6667 21.7332 14.4 21.9999 14.4L21.4666 14.9333Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21.4666 21.0667C21.4666 20.8 21.7332 20.5333 21.9999 20.5333M22.5332 14.9333C22.5332 15.2 22.2666 15.4667 21.9999 15.4667L22.5332 14.9333ZM21.9999 20.5333C22.2666 20.5333 22.5332 20.8 22.5332 21.0667L21.9999 20.5333Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.5332 21.0667C22.5332 21.3334 22.2666 21.6 21.9999 21.6M21.9999 21.4667C21.7332 21.4667 21.4666 21.2 21.4666 20.9333L21.9999 21.4667Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g>
                </svg>
              </template>
            </FancyChooser>
          </div>

          <div class="col">
            <FancyChooser
              @click="selectionData.bulk.multipleLocations = true"
              :isSelected="selectionData.bulk.multipleLocations == true"
            >
              <template v-slot:title>Mehrere Standorte</template>
              <template v-slot:icon>
                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                  <g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M2.75,5.25h9.5a.5.5,0,0,1,.5.5v17.5a0,0,0,0,1,0,0H2.25a0,0,0,0,1,0,0V5.75A.5.5,0,0,1,2.75,5.25Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M5.75,2.25h3.5a.5.5,0,0,1,.5.5v2.5a0,0,0,0,1,0,0H5.25a0,0,0,0,1,0,0V2.75A.5.5,0,0,1,5.75,2.25Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M5.25 8.25L9.75 8.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M5.25 11.25L9.75 11.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M5.25 14.25L9.75 14.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M5.25 17.25L9.75 17.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M5.25 20.25L9.75 20.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M8.25 0.75L8.25 2.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M15.75,23.25h6V10.5A.75.75,0,0,0,21,9.75H16.5a.75.75,0,0,0-.75.75V23.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M20.25 8.25L20.25 9.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M0.75 23.25L23.25 23.25" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g>
                </svg>
              </template>
            </FancyChooser>
          </div>
        </div>

        <p>Bitte auswählen:</p>

        <div class="shipping__option-duplex">
          <div class="shipping__option">
            <slot v-if="selectionData.bulk.multipleLocations">
              <div class="shipping__icon">
                <img src="@/assets/images/landing-page/flags/de.svg" alt="Deutschland Flag">
              </div>

              <div class="shipping__label">
                Deutschland
                <small v-if="$store.getters.isB2b">1,90 € pro Präsent, zzgl. MwSt.<br><span class="u-text-light">{{ splittedTaxSingle(1.9) }} inkl. MwSt.</span></small>
                <small v-else>{{ splittedTaxSingle(1.9) }} pro Präsent, inkl. MwSt.<br><span class="u-text-light">1,90 € zzgl. MwSt.</span></small>
              </div>
            </slot>

            <FormInput
              v-else
              type="radio"
              name="shippingInternational"
              @change="val => selectionData.bulk.international = false"
              :checked="selectionData.bulk.international === false"
            >
              <div class="shipping__icon">
                <img src="@/assets/images/landing-page/flags/de.svg" alt="Deutschland Flag">
              </div>

              <div class="shipping__label">
                Deutschland
                <small v-if="$store.getters.isB2b">1,90 € pro Präsent, zzgl. MwSt.<br><span class="u-text-light">{{ splittedTaxSingle(1.9) }} inkl. MwSt.</span></small>
                <small v-else>{{ splittedTaxSingle(1.9) }} pro Präsent, inkl. MwSt.<br><span class="u-text-light">1,90 € zzgl. MwSt.</span></small>
              </div>
            </FormInput>
          </div>

          <div v-if="selectionData.bulk.multipleLocations" class="shipping__select">
            <FormSelect @change="(v) => selectionData.bulk.regions.de = parseInt(v)">
              <option value="0" :selected="selectionData.bulk.regions.de === 0">0</option>
              <option v-for="i in Math.max(0, boxQty - selectionData.bulk.regions.other)" :key="i" :value="i" :selected="selectionData.bulk.regions.de === i">{{ i }}</option>
            </FormSelect>
            Präsente
          </div>
        </div>

        <div class="shipping__option-duplex">
          <div class="shipping__option">
            <slot v-if="selectionData.bulk.multipleLocations">
              <div class="shipping__icon">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#B7ECEC"/><path d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.66659 27.7333L7.99992 21H9.43992C9.74402 21.001 10.0443 20.9318 10.3172 20.7976C10.5901 20.6635 10.8283 20.4681 11.0133 20.2267C11.2037 19.9908 11.3357 19.7132 11.3982 19.4166C11.4608 19.1199 11.4522 18.8127 11.3733 18.52L10.3733 14.52C10.2685 14.0864 10.0208 13.7006 9.67005 13.4249C9.31935 13.1492 8.88604 12.9995 8.43992 13H1.33325" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M27.9999 7H22.5599C22.1137 6.9995 21.6804 7.14916 21.3297 7.42489C20.979 7.70062 20.7313 8.08636 20.6265 8.52L19.6265 12.52C19.5493 12.8137 19.5429 13.1216 19.6078 13.4183C19.6727 13.7149 19.8071 13.992 19.9999 14.2267C20.1848 14.4681 20.423 14.6635 20.6959 14.7976C20.9688 14.9318 21.2691 15.001 21.5732 15H23.6799L24.7199 21.3333C24.7979 21.7951 25.0354 22.2148 25.3912 22.5194C25.7469 22.824 26.1982 22.9941 26.6665 23H29.3332" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>

              <div class="shipping__label">
                Ausland
                <small>Preis auf Anfrage <IconTooltip>In Abhängigkeit von der gewünschten Stückzahl sowie dem tatsächlichen Lieferland können die Versandkosten erheblich variieren. Beim Versand außerhalb der EU können zudem Zollabgaben / weitere Gebühren auftreten. Nehmen Sie bitte mit uns Kontakt auf.</IconTooltip></small>
              </div>
            </slot>

            <FormInput
              v-else
              type="radio"
              name="shippingInternational"
              @change="val => selectionData.bulk.international = true"
              :checked="selectionData.bulk.international === true"
            >
              <div class="shipping__icon">
                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#B7ECEC"/><path d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.66659 27.7333L7.99992 21H9.43992C9.74402 21.001 10.0443 20.9318 10.3172 20.7976C10.5901 20.6635 10.8283 20.4681 11.0133 20.2267C11.2037 19.9908 11.3357 19.7132 11.3982 19.4166C11.4608 19.1199 11.4522 18.8127 11.3733 18.52L10.3733 14.52C10.2685 14.0864 10.0208 13.7006 9.67005 13.4249C9.31935 13.1492 8.88604 12.9995 8.43992 13H1.33325" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M27.9999 7H22.5599C22.1137 6.9995 21.6804 7.14916 21.3297 7.42489C20.979 7.70062 20.7313 8.08636 20.6265 8.52L19.6265 12.52C19.5493 12.8137 19.5429 13.1216 19.6078 13.4183C19.6727 13.7149 19.8071 13.992 19.9999 14.2267C20.1848 14.4681 20.423 14.6635 20.6959 14.7976C20.9688 14.9318 21.2691 15.001 21.5732 15H23.6799L24.7199 21.3333C24.7979 21.7951 25.0354 22.2148 25.3912 22.5194C25.7469 22.824 26.1982 22.9941 26.6665 23H29.3332" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>

              <div class="shipping__label">
                Ausland
                <small>Preis auf Anfrage <IconTooltip>In Abhängigkeit von der gewünschten Stückzahl sowie dem tatsächlichen Lieferland können die Versandkosten erheblich variieren. Beim Versand außerhalb der EU können zudem Zollabgaben / weitere Gebühren auftreten. Nehmen Sie bitte mit uns Kontakt auf.</IconTooltip></small>
              </div>
            </FormInput>
          </div>

          <div v-if="selectionData.bulk.multipleLocations" class="shipping__select">
            <FormSelect @change="(v) => selectionData.bulk.regions.other = parseInt(v)">
              <option value="0" :selected="selectionData.bulk.regions.other === 0">0</option>
              <option v-for="i in Math.max(0, boxQty - selectionData.bulk.regions.de)" :key="i" :value="i" :selected="selectionData.bulk.regions.other === i">{{ i }}</option>
            </FormSelect>
            Präsente
          </div>
        </div>

        <Notice v-if="selectionData.bulk.multipleLocations === true">
          <template v-slot:icon>
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
              <g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M9.000 7.500 A3.000 3.000 0 1 0 15.000 7.500 A3.000 3.000 0 1 0 9.000 7.500 Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M12,.75A6.75,6.75,0,0,1,18.75,7.5c0,3.251-5.132,10.527-6.446,12.337a.377.377,0,0,1-.608,0C10.382,18.027,5.25,10.751,5.25,7.5A6.75,6.75,0,0,1,12,.75Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M17.979,17.784c2.732.541,4.521,1.444,4.521,2.466,0,1.657-4.7,3-10.5,3s-10.5-1.343-10.5-3c0-1.02,1.781-1.921,4.5-2.463" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g>
            </svg>
          </template>

          <p>Die Eingabe erfolgt mit Hilfe einer Excel-Vorlage, welche Sie nach der Bestellung per eMail erhalten.</p>
        </Notice>
      </ModuleSection>
      <p class="u-text-dimmed" v-if="selectionData.bulk.international === false || (selectionData.bulk.multipleLocations === true && selectionData.bulk.regions.de > 0)">Die angegebenen Kosten enthalten neben dem reinen Porto auch die Versandverpackung (z.B. Kartons, Füllmaterial) sowie deren Handling.</p>
      <ModuleSection
        title="Optionale Services"
        icon='<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M0.750 12.023 A2.625 2.625 0 1 0 6.000 12.023 A2.625 2.625 0 1 0 0.750 12.023 Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M18.000 12.023 A2.625 2.625 0 1 0 23.250 12.023 A2.625 2.625 0 1 0 18.000 12.023 Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M9.375 12.023 A2.625 2.625 0 1 0 14.625 12.023 A2.625 2.625 0 1 0 9.375 12.023 Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>'
      >
        <p>
          <FormInput
            type="checkbox"
            value="1"
            v-model="cardboardBoxWrap"
            :checked="cardboardBoxWrap"
          >
            <b>Ein Versandkarton pro Präsent</b>
            <br>
            <small style="display: inline !important;">{{ humanPrice($store.getters.getPricesSinglePackageProduct.default_net) }} zzgl. MwSt. pro Präsent</small>
            <br>
            <small>Empfohlen bei kundenseitigem Weiterversand. <IconTooltip>Standardmäßig erfolgt die Lieferung in Großkartonagen, welche bis zu 27 Präsente enthalten. Bei Auswahl der Option "Ein Versandkarton pro Präsent" werden die Präsente in einzelnen Versandkartons mit Füllmaterial verpackt, wodurch ein sicherer Weiterversand durch den Kunden ermöglicht wird.</IconTooltip></small>
          </FormInput>
        </p>
      </ModuleSection>
    </template>

    <template v-slot:footer>
      <Button
        @click="submit()"
        appearance="primary"
      >
        Auswahl bestätigen
      </Button>

      <Button
        @click="$refs.modal.close()"
        appearance="secondary"
      >
        Abbrechen
      </Button>
    </template>
  </Modal>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';

import Modal from '@/components/Composer/Modal';
import Button from '@/components/Common/Button';
import Notice from '@/components/Composer/Notice';
import FormInput from '@/components/Common/FormInput';
import FormSelect from '@/components/Common/FormSelect';
import FancyChooser from '@/components/Composer/FancyChooser';
import IconTooltip from '@/components/Common/IconTooltip';
import FlashMessage from '@/components/Composer/FlashMessage';
import ModuleSection from '@/components/Composer/ModuleSection';

export default {
  name: 'ModalShippingBulk',
  props: {
    selectionData: {
      type: Object
    }
  },
  data () {
    return {
      cardboardBoxWrap: false
    };
  },
  mixins: [logicMixin],
  components: {
    Modal,
    Button,
    Notice,
    FormInput,
    FormSelect,
    FancyChooser,
    IconTooltip,
    FlashMessage,
    ModuleSection
  },
  methods: {
    submit () {
      this.selectionData.main.mode = 4;
      this.selectionData.bulk.cardboardBoxWrap = this.cardboardBoxWrap;

      this.$refs.modal.close({
        submit: true
      });
    }
  },
  mounted() {
    if (this.selectionData.bulk.regions.de === 0 && this.selectionData.bulk.regions.other === 0) {
      this.selectionData.bulk.regions.de = this.boxQty;
    }
    this.cardboardBoxWrap = this.selectionData.bulk.cardboardBoxWrap;
  }
};
</script>

<style lang="scss" scoped>
/**
 * ModalShippingBulk
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Bulk Shipping Options
 * @since 2022-09-07
**/

$component: 'modal-shipping-bulk';

.#{$component} {
  //…

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
